export default __webpack_public_path__ + "ba79423b6ff7bb7327d646b656e650ba.png";